import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { IOperative } from '../../../message-models/operative.interface';
import { TrainingTypeService } from '../../../training-records/services/training-type.service';
import { TrainingRecordsService } from '../../../training-records/services/training-records.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TrainingType } from '../../../message-models/training-record-type.class';
import { ITrainingType } from '../../../message-models/training-record-type.interface';
import { CompanyService } from '../../../company/services/company.service';
import { EcaBreadcrumbService } from '../../../eca-breadcrumb/services/eca-breadcrumb.service';
import { TrainingTypeDocumentService } from '../../../training-records/services/training-type-document.service';
import { IEntityDocumentSummary } from '../../../message-models/entity-document-summary';
import { DocumentEntityType } from '../../../message-models/document-entity-type.enum';
import { DocumentModalService } from '../../../documents/services/document-modal.service';
import { DocumentService } from '../../../documents/services/document.service';
import { ObservationModalService } from '../../../observations/services/observation-modal.service';
import { ObservationsService } from '../../../observations/services/observations.service';
import { DetailContainerComponent } from '../../../common/components/detail-container/detail-container.component';
import { OurUserService } from '../../../users/services/user.service';
import { IUserInfo } from '../../../users/models/userInfo.interface';
import { consts } from '../../../common/modals/consts';
import { Subscription } from 'rxjs';
import { ErrorHandlingService } from '../../../services/error-handling.service';
import { AlertsService } from '../../../alerts/services/alerts.service';
import { HelpModalService } from '../../../help/services/help-modal.service';
import { EcaConfirmDeleteModalOptions } from "../../../shared/models/confirm-delete-modal-options.class";
import { EcaConfirmProcessService } from '../../../shared/services/eca-confirm-process.service';
import { IBreadcrumb } from '../../../eca-breadcrumb/models/breadcrumb.interface';

@Component({
  selector: 'app-company-training-course-details',
  templateUrl: './company-training-course-details.component.html',
  styleUrls: ['./company-training-course-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class TrainingCourseDetailsComponent implements OnInit {
  @ViewChild('ttDetailsContainerComponent') ttDetailsContainerComponent: DetailContainerComponent;
  editingDetails: boolean;
  private trainingTypeId: string;
  trainingTypes: ITrainingType[] = [];
  trainingType: TrainingType = new TrainingType({} as ITrainingType);
  trainingTypeDocuments: IEntityDocumentSummary[] = [];
  public loggedInUser: IUserInfo;
  public companyId: string = consts.emptyGuid;
  loggedInUserSubscription: Subscription;
  tempTrainingType: TrainingType = new TrainingType();
  isTrainingTypeLoading: boolean = false;
  saveAttempted: boolean = false;

  constructor(private route: ActivatedRoute,
    private trainingTypeService: TrainingTypeService,
    private trainingRecordsService: TrainingRecordsService,
    private trainingTypeDocumentService: TrainingTypeDocumentService,
    private companyService: CompanyService,
    private helpService: HelpModalService,
    private ecaBreadcrumbService: EcaBreadcrumbService,
    private documentModalService: DocumentModalService,
    private documentService: DocumentService,
    private confirmProcessService: EcaConfirmProcessService,
    private alertsService: AlertsService,
    private observationModalService: ObservationModalService,
    private observationsService: ObservationsService,
    private userService: OurUserService,
    private router: Router,
    private errorHandlingService: ErrorHandlingService) {
  }

  ngOnInit(): void {
    this.trainingTypeId = this.route.snapshot.params.trainingTypeId;
    this.isTrainingTypeLoading = true;
    this.userService.getLoggedInUser().subscribe(() => {
    
      this.loggedInUserSubscription = this.userService.getLoggedInUserSubject().subscribe(user => {
        this.loggedInUser = user;
        this.companyId = this.loggedInUser?.companyId;
        if (this.companyId !== consts.emptyGuid || this.companyId !== undefined) {
          this.trainingRecordsService.getTrainingTypesForId(this.trainingTypeId).subscribe(trainingType => {
            this.trainingType = new TrainingType(trainingType);
            this.tempTrainingType = new TrainingType(this.trainingType);
            this.getTrainingTypeDocuments();
            this.isTrainingTypeLoading = false;
            
          })
        }
      });
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });

    this.populateBreadcrumbs();
  }

  getTrainingTypeDocuments(includeExpired: boolean = false) {
    this.trainingTypeDocumentService.getAllTrainingTypeDocumentSummaries(this.companyId, this.trainingType.id, includeExpired).subscribe(trainingTypeDocuments => {
      this.trainingTypeDocuments = [];
      trainingTypeDocuments.forEach(doc => this.trainingTypeDocuments.push(doc));
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
  }

  editDetails() {
    if (this.ttDetailsContainerComponent.isCollapsed) {
      //this.trDetailsContainerComponent.expandClicked();
      this.ttDetailsContainerComponent.panelToggle();
    }
    this.editingDetails = true;
    // this.tempTrainingRecord = new TrainingRecord(this.trainingRecord);
  }

  cancelEdit() {
    this.tempTrainingType = new TrainingType(this.trainingType as ITrainingType);
    this.editingDetails = false;
  }

  saveDetails() {
    if (this.tempTrainingType.isValid) {
      this.isTrainingTypeLoading = true;
      this.trainingRecordsService.createOrUpdateCompanyTrainingType(new TrainingType(this.tempTrainingType)).subscribe(trainingType => {
        this.trainingType = new TrainingType(trainingType);
        this.tempTrainingType = new TrainingType(this.trainingType as ITrainingType);
        this.editingDetails = false;
        this.isTrainingTypeLoading = false;
      }, () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      });
    }
  }

  viewTrainingTypeDocument(entityDocumentSummary: IEntityDocumentSummary) {
    this.router.navigate(['training-course-document', entityDocumentSummary.documentId]);
  }
  downloadTrainingTypeDocument(entityDocumentSummary: IEntityDocumentSummary) {
    this.documentService.downloadOrOpenDocument(entityDocumentSummary, true);
  }

  deleteTrainingTypeDocumentClick(entityDocumentSummary: IEntityDocumentSummary) {
    this.confirmProcessService.openConfirmProcessModal('Are you sure you want to remove this document?',
      'Remove ' + entityDocumentSummary.originalFilename, new EcaConfirmDeleteModalOptions()).subscribe({
        next: response => {
          if (response) {
            this.deleteTrainingTypeDocument(entityDocumentSummary);
          }
        }
      });
  }

  deleteTrainingTypeDocument(entityDocumentSummary: IEntityDocumentSummary) {
    this.trainingTypeDocumentService.deleteTrainingTypeDocument(entityDocumentSummary.documentId, this.companyId).subscribe(
      result => {
        if (result) {
          const documentIndex = this.trainingTypeDocuments.findIndex(c => c.documentId !== entityDocumentSummary.documentId);
          this.trainingTypeDocuments.splice(documentIndex, 1);
          this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();

        }
      }, () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      });
  }

  addTrainingTypeDocument() {
    this.documentModalService.openDocumentUploaderModal(null, DocumentEntityType.trainingCourse, 'Add Document')
      .subscribe(documentModalRef => {
        documentModalRef.content.documentUploadSave.subscribe((documentUploadRequest: FormData) => {
          documentModalRef.dynamicDialogRef.close();
          documentUploadRequest.append('TrainingTypeId', this.trainingType.id);
          documentUploadRequest.append('CompanyId', this.companyId);

          this.trainingTypeDocumentService
            .createOrUpdateTrainingTypeDocument(documentUploadRequest).subscribe(trainingTypeSummary => {
              this.trainingTypeDocuments.unshift(trainingTypeSummary);
            }, () => {
              this.errorHandlingService.showErrorWarning().subscribe(() => {
              });
            });
        });
      });
  }

  private populateBreadcrumbs() {
    console.log(this.tempTrainingType);
    const operativeBreadCrumbs = new Array<IBreadcrumb>();
    operativeBreadCrumbs.push({ label: 'Training Courses', iconName: 'users-class', routeLink: '/training-courses' } as IBreadcrumb);
    operativeBreadCrumbs.push({ label: 'Course Detail', iconName: 'users-class' } as IBreadcrumb);
    this.ecaBreadcrumbService.breadCrumbs.next(operativeBreadCrumbs);
  }
}
